import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DialogState {
    visible: boolean;
    message: string;
    confirmAction?: string;
    resultList?: { id: string | number; message: string }[];
}

const initialState: DialogState = {
    visible: false,
    message: "",
    confirmAction: undefined,
    resultList: undefined,
};

const dialogSlice = createSlice({
    name: "dialog",
    initialState,
    reducers: {
        showDialog: (
            state,
            action: PayloadAction<{
                message?: string;
                confirmAction?: string;
                visible?: boolean;
                resultList?: { id: string | number; message: string }[];
            }>
        ) => {
            state.visible = action.payload.visible ?? true;
            state.message = action.payload.message ?? "";
            state.confirmAction = action.payload.confirmAction;
            state.resultList = action.payload.resultList;
        },
        hideDialog: (state) => {
            state.visible = false;
            state.message = "";
            state.confirmAction = undefined;
            state.resultList = undefined;
        },
    },
});

export const { showDialog, hideDialog } = dialogSlice.actions;
export default dialogSlice.reducer;
